import { DecorationSet } from '@atlaskit/editor-prosemirror/view';
export const manageSelectionMarkerView = (getPluginState, api) => () => {
  // If the plugin doesn't exist let's avoid running this code.
  if (!(api !== null && api !== void 0 && api.selectionMarker)) {
    return {};
  }
  let releaseSelectionMarker;
  return {
    update: editorView => {
      const pluginState = getPluginState(editorView.state);
      const modalIsOpen = pluginState.modalDecorationSet !== DecorationSet.empty;
      if (modalIsOpen && !releaseSelectionMarker) {
        var _api$selectionMarker;
        releaseSelectionMarker = api === null || api === void 0 ? void 0 : (_api$selectionMarker = api.selectionMarker) === null || _api$selectionMarker === void 0 ? void 0 : _api$selectionMarker.actions.hideDecoration();
      } else if (!modalIsOpen && releaseSelectionMarker) {
        releaseSelectionMarker();
        releaseSelectionMarker = undefined;
      }
    },
    destroy: () => {
      var _releaseSelectionMark;
      (_releaseSelectionMark = releaseSelectionMarker) === null || _releaseSelectionMark === void 0 ? void 0 : _releaseSelectionMark();
    }
  };
};